import { useHandleTransactionRequest } from "./useHandleTransactionRequest";

type ApiAssetId =
  | { tag: "Ada" }
  | { tag: "NativeToken"; policyId: string; assetName: string };

type ApiAssetValue = {
  asset: ApiAssetId;
  value: number;
};

type WithdrawPayload = {
  value: { assets: ApiAssetValue[] };
};

export const useHandleWithdrawRequest = () => {
  return useHandleTransactionRequest<WithdrawPayload>("Withdraw");
};
